import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFromMap',
})
export class GetFromMapPipe implements PipeTransform {
  public transform<T extends string | number, V>(map: Record<T, V>, key: T, defaultValue: V): V {
    return map?.[key] ?? defaultValue;
  }
}
